import { FC } from 'react'
import { Col, Container, Row } from 'react-grid-system'
import styled from 'styled-components'
import { SimpleTextWithIconCard } from '../molecules'
import textsData from '@/textData/ContractInfoDetailCardTexts.json'
import houseIcon from '@/assets/house-icon.svg'
import doorIcon from '@/assets/door-icon.svg'
import calendarIcon from '@/assets/calendar-icon.svg'
import mapIcon from '@/assets/map-icon.svg'
import { useUserLanguage } from '@/customHooks'

type ContractInfoCard = {
  property: string
  unit: string
  location: string
  contractTerm: string
}

const Wrapper = styled(Container)`
  border-radius: ${({ theme }) => theme.border.radius.md};
  border-style: solid;
  border-width: 1px;
  border-color: ${({ theme }) => theme.colors.border};
`

export const ContractDetailCard: FC<ContractInfoCard> = ({ property, unit, location, contractTerm }) => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  return (
    <Wrapper>
      <Row>
        <Col md={6}>
          <SimpleTextWithIconCard
            icon={houseIcon}
            title={texts.property}
            description={property}
          />
        </Col>
        <Col md={6}>
          <SimpleTextWithIconCard
            icon={doorIcon}
            title={texts.unit}
            description={unit}
          />
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <SimpleTextWithIconCard
            icon={mapIcon}
            title={texts.location}
            description={location}
          />
        </Col>
        <Col md={6}>
          <SimpleTextWithIconCard
            icon={calendarIcon}
            title={texts.term}
            description={contractTerm}
          />
        </Col>
      </Row>
    </Wrapper>
  )
}